import React from "react";
import { Flex } from "@chakra-ui/react";
import {
  AutoComplete,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from "@choc-ui/chakra-autocomplete";

export default function CommonAutocomplete({placeholder,options,handleClick}) {
  return (
    <Flex
    //   boxSize="full"
      pos="absolute"
    //   p={30}
    w="180px"
    
      justifyContent="center"
    >
      <AutoComplete rollNavigation>
        <AutoCompleteInput placeholder={placeholder}  />
        <AutoCompleteList>
          {options.map((option, oid) => (
            <AutoCompleteItem
              key={`option-${oid}`}
              value={option}
              onClick={()=>{handleClick(option)}}
            //   textTransform="capitalize"
            >
              {option}
            </AutoCompleteItem>
          ))}
        </AutoCompleteList>
      </AutoComplete>
    </Flex>    
  )
}



  
